// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2598":"283d2663","3006":"f63186ac","3868":"f63186ac","4477":"f63186ac"}[chunkId] + ".chunk.css";
};